import '../../styles/FilterForArchive.css';
import Selector from '../CustomElements/Selector';
import Input from '../CustomElements/Input';
import { handleUniversalChange } from '../../utils/formUtils';

function FilterForArchiveIUR({ formData, setFormData, t, options }) {
  return (
    <div className="filter-for-archive_select">
      <Selector
        options={options?.alertType}
        onChange={(selectedOption) => {
          handleUniversalChange(formData, setFormData, null, 'iurAlertType', selectedOption, 'select');
        }}
        value={
          formData.iurAlertType || formData.iurAlertType === 0
            ? options.alertType?.find((option) => option.value === formData.iurAlertType)
            : null
        }
        name="iurAlertType"
        isMulti={false}
        label={t?.signalIurLabel || 'Сигнал на ИУР'}
        placeholder={t?.alertTypePlaceholder || 'Выберите сигнал'}
      />
      <Input
        onChange={(event) => handleUniversalChange(formData, setFormData, event)}
        value={formData?.iurGPS}
        name="iurGPS"
        label={t?.amountGPSLabel || 'Количество спутников'}
        placeholder={t?.amountGPSPlaceholder || 'Введите количество спутников'}
      />
      <Selector
        options={options?.gsm}
        onChange={(selectedOption) => {
          handleUniversalChange(formData, setFormData, null, 'iurGSM', selectedOption, 'select');
        }}
        value={formData.iurGSM ? options?.gsm?.find((option) => option.value === formData.iurGSM) : null}
        name="iurGSM"
        isMulti={false}
        label={t?.signalLevelLabel || 'Уровень сигнала сотовой связи'}
        placeholder={t?.signalLevelPlaceholder || 'Выберите уровень сигнала'}
      />
      <Selector
        options={options?.connect}
        onChange={(selectedOption) => {
          handleUniversalChange(formData, setFormData, null, 'iurConn', selectedOption, 'select');
        }}
        value={formData.iurConn !== '' ? options?.connect?.find((option) => option.value === formData.iurConn) : null}
        name="iurConn"
        isMulti={false}
        label={t?.connectLabel || 'Связь с сервером'}
        placeholder={t?.connectPlaceholder || 'Выберите наличие связи'}
      />
    </div>
  );
}

export default FilterForArchiveIUR;
